module.exports = __webpack_public_path__ + "img/car_damage_detail_outline.df9005e8.svg";